import { connect } from 'react-redux';
//
import { IStoreState } from 'store';
import DealList from 'components/deal-list/deal-list';
import { filterDealsBySearchKeyword } from 'store/deals/helpers';
import { getTokenPayload } from 'lib/auth';
import { removeUserGroup } from 'lib/helpers/name-formatters';
import { ELoadingType } from 'store/loading/types';

const mapStateToProps = ({ deals, fieldOptions, loading }: IStoreState) => {
  const { error, data, searchFilter, searchKeyword, statusFilter } = deals;
  const { loading: loadingState } = loading;
  const { regions, productLines, statuses } = fieldOptions;
  const idTokenResponse = getTokenPayload();
  const employeeName = idTokenResponse ? removeUserGroup(idTokenResponse.name).toLowerCase() : null;
  // Search all field visible on dashboard table
  const fields = [
    'createdBy',
    'createdOn',
    'customer',
    'modifiedBy',
    'modifiedOn',
    'name',
    'region',
    'productLine',
    'status',
  ];

  return {
    loading: loadingState !== ELoadingType.NONE,
    error,
    filteredDeals: filterDealsBySearchKeyword(employeeName, data, fields, searchFilter, searchKeyword, statusFilter),
    regions,
    productLines,
    statuses,
  };
};

export default connect(mapStateToProps)(DealList);
